import {useQuery} from "@tanstack/react-query";
import {getAllRestorants} from "../../../store/Settings/api";
import {allergensLoad} from "../../../store/Dish/api";

export const useGetAllergens = () => {
    return useQuery(["allergens"], allergensLoad)
}
